interface QueryParams {
  [key: string]: string[];
}

export function useQuery(str?: string, source?: string): QueryParams {
  let queryString = str || window.location.search || "";
  let keyValPairs: string[] = [];
  let params: QueryParams = {};

  queryString = queryString.replace(/.*?\?/, "");

  if (queryString.length) {
    keyValPairs = queryString.split("&");
    for (let pairNum in keyValPairs) {
      const key = keyValPairs[pairNum].split("=")[0];

      if (!key[0]?.length) continue;
      if (typeof params[key] === "undefined") params[key] = [];
      params[key].push(keyValPairs[pairNum].split("=")[1]);
    }
  }
  const { sort_by, for_sale } = params;
  if (!sort_by) {
    params["sort_by"] = ["cheapest"];
    params["for_sale"] = ["true"];

    if (for_sale) {
      if (for_sale.includes("false")) {
        delete params["sort_by"];
      } else {
        // Keep existing logic
      }
    }
  } else {
    if (sort_by.includes("cheapest")) {
      params["for_sale"] = ["true"];
    }
  }
  return params;
} 